import cn from "classnames";
import s from "../Card.module.scss";

export const CardRow: RFC<{ className?: string }> = ({ className, children }) => {
  return <div className={cn(s.row, className)}>{children}</div>;
};

CardRow.displayName = "CardRow";
